var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import GeoItem from './geoitem';
var Text = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 32px;\n    letter-spacing: -0.02em;\n    color: #151514;\n    margin-bottom: 48px;\n\n  a {\n    font-weight: bold;\n    color: #151514;\n\n    &:hover {\n      text-decoration: none;\n      color: #151514;\n    }\n  }\n"], ["\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 32px;\n    letter-spacing: -0.02em;\n    color: #151514;\n    margin-bottom: 48px;\n\n  a {\n    font-weight: bold;\n    color: #151514;\n\n    &:hover {\n      text-decoration: none;\n      color: #151514;\n    }\n  }\n"])));
var ItemsModule = function (props) {
    var items = props.items;
    var modulesGeo = items.map(function (item, i) {
        return React.createElement("div", { key: i, className: "col-xl-6 col-lg-6 col-12 spec-geo-item-container spec-geo-id-".concat((item === null || item === void 0 ? void 0 : item.geoItemId) || (i + 1)) },
            React.createElement(GeoItem, __assign({}, props, { image: item.image.urlImage, num: item.texts[0].textObject.name, title: item.texts[1].textObject.name, text: item.texts[2].textObject.name, isLast: i === items.length - 1 ? true : false, itemProps: item })));
    });
    return React.createElement(React.Fragment, null, modulesGeo);
};
export default ItemsModule;
var templateObject_1;
//# sourceMappingURL=itemsblock.js.mapvar __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import GeoItem from './geoitem';
var Text = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 32px;\n    letter-spacing: -0.02em;\n    color: #151514;\n    margin-bottom: 48px;\n\n  a {\n    font-weight: bold;\n    color: #151514;\n\n    &:hover {\n      text-decoration: none;\n      color: #151514;\n    }\n  }\n"], ["\n    font-family: inherit;\n    font-style: normal;\n    font-weight: normal;\n    font-size: 20px;\n    line-height: 32px;\n    letter-spacing: -0.02em;\n    color: #151514;\n    margin-bottom: 48px;\n\n  a {\n    font-weight: bold;\n    color: #151514;\n\n    &:hover {\n      text-decoration: none;\n      color: #151514;\n    }\n  }\n"])));
var ItemsModule = function (props) {
    var items = props.items;
    var modulesGeo = items.map(function (item, i) {
        return React.createElement("div", { key: i, className: "col-xl-6 col-lg-6 col-12 spec-geo-item-container spec-geo-id-".concat((item === null || item === void 0 ? void 0 : item.geoItemId) || (i + 1)) },
            React.createElement(GeoItem, __assign({}, props, { image: item.image.urlImage, num: item.texts[0].textObject.name, title: item.texts[1].textObject.name, text: item.texts[2].textObject.name, isLast: i === items.length - 1 ? true : false, itemProps: item })));
    });
    return React.createElement(React.Fragment, null, modulesGeo);
};
export default ItemsModule;
var templateObject_1;
//# sourceMappingURL=itemsblock.js.map